module.exports = __webpack_public_path__ + "static/community-slideshow-03@2x-f516a6a88b5dad566cd2dc4e622357db.jpg";